export default __webpack_public_path__ + "static/media/bringSmile.c9868836.png";